import React from 'react';
import { useNavigate } from 'react-router';
import { BellIcon, ArrowRight } from '@phosphor-icons/react';

import { useUserSession } from 'src/hooks/useUserSession';

import { useRenterNotifications } from 'src/queries';

import { Stack } from 'src/components/themed/Stack';
import { Button } from 'src/components/themed/Button';
import { Typography } from 'src/components/themed/Typography';

/**
 * Entry point to the renter notification feed (rental-clock v2.1 §5–§6) with its unread
 * badge. The feed is the renter's channel for rental events now that Telegram for renters
 * is postponed, so it needs to be reachable from the cabinet rather than only linked from
 * an email.
 *
 * Hidden without a session: the feed is scoped by account on the server, and a visitor has no
 * account to read.
 */
export const NotificationsCard = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useUserSession();
  const { data } = useRenterNotifications({ enabled: isLoggedIn });

  if (!isLoggedIn) {
    return null;
  }

  const unreadCount = data?.pages[0]?.unreadCount ?? 0;

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      width="100%"
      pl={4}
    >
      <Stack flexDirection="row" gap={2} alignItems="center">
        <BellIcon size={22} color="white" weight="fill" />
        <Typography color="white" fontWeight="600">
          Notifications
          {unreadCount > 0 ? ` (${unreadCount} new)` : ''}
        </Typography>
      </Stack>
      <Button
        onClick={() => navigate('/notifications')}
        title="Open"
        variant="transparent"
        textColor="white"
        iconLeft={<ArrowRight size={20} color="white" />}
      />
    </Stack>
  );
};
